import axiosInstance from "../../../api/axiosInstance";

export const fetchIpaSymbols = async (params) => {
  try {
    const cleaned = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v != null)
    );
    const res = await axiosInstance.get("/public/ipa/symbols", { params: cleaned });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch symbols" };
  }
};

export const fetchIpaSymbolById = async (id) => {
  try {
    const res = await axiosInstance.get(`/public/ipa/symbols/${id}`);
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch symbol" };
  }
};

export const fetchIpaLessons = async (params) => {
  try {
    const cleaned = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v != null)
    );
    const res = await axiosInstance.get("/public/ipa/lessons", { params: cleaned });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch lessons" };
  }
};

export const fetchIpaLessonById = async (id) => {
  try {
    const res = await axiosInstance.get(`/public/ipa/lessons/${id}`);
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch lesson" };
  }
};
